import { useEffect, useState } from "react";
import API from "../services/ApiService";
import StreakFlame from "./Streak";
import { safeApiCall } from "../utils/safeApiCall";
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary"
import { useAuth } from "../context/AuthContext";


export default function YourStats() {
    const [ghostStreak, setGhostStreak] = useState(0);
    const [roomStreak, setRoomStreak] = useState(0);
    const [ghostActive, setGhostActive] = useState(false);
    const [roomActive, setRoomActive] = useState(false);
    const { contextUser, isLoggedIn } = useAuth();

    useEffect(() => {
        if (!contextUser) return;
        const fetchGhostStreak = async () => {
            const response = await safeApiCall(API.getGhostStreak, {data: {streak: 0, last_played: "2012-12-12"}});
            setGhostStreak(response.data.streak);
            if (response.data.last_played === new Date().toISOString().split('T')[0]) {
                setGhostActive(true);
            }
        }
        const fetchRoomStreak = async () => {
            const response = await safeApiCall(API.getRoomStreak, {data: {streak: 0, last_played: "2012-12-12"}});
            setRoomStreak(response.data.streak);
            if (response.data.last_played === new Date().toISOString().split('T')[0]) {
                setRoomActive(true);
            }
        }
        fetchGhostStreak();
        fetchRoomStreak();
    }, [contextUser, isLoggedIn]);

    return (
        <div className="your-stats-container">
            <div className="streaks-container">
                <div className="streak-container">
                    <h3>Ghost Streak</h3>
                    <ErrorBoundary>
                        <p><StreakFlame streak={ghostStreak} active={ghostActive} color={[180, 0, 0]}/></p>
                    </ErrorBoundary>
                </div>
                <div className="streak-container">
                    <h3>Room Streak</h3>
                    <ErrorBoundary>
                        <p><StreakFlame streak={roomStreak} active={roomActive} color={[128, 0, 128]}/></p>
                    </ErrorBoundary>
                </div>
            </div>
            {!ghostActive && !roomActive && (
                <p>Play to <span className="neon-red">ignite</span> the <span className="neon-red">fire</span></p>
            )}
        </div>
    );
} 